import { Colours } from '@hummingbirdtechgroup/crips-ui';

const card = {
  backgroundColor: Colours.white,
  borderRadius: 4,
  boxShadow: [3, 0, 15, '#eaedf5'],
};

export default card;
